"use client"

import { useEffect, useState } from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

import { useColorMode } from "@/components/ui"

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  const reCaptchaSiteKey = process.env.RECAPTCHA_SITE_KEY
  const [nonce, setNonce] = useState<string>("")

  useEffect(() => {
    // Get nonce from meta tag on client-side
    const metaNonce = document
      .querySelector('meta[name="csp-nonce"]')
      ?.getAttribute("content")
    if (metaNonce) {
      setNonce(metaNonce)
    }
  }, [])

  if (!reCaptchaSiteKey) {
    console.error("RECAPTCHA_SITE_KEY is not set")
  }
  return (
    <>
      <GoogleReCaptchaProvider
        container={{
          // optional to render inside custom element
          // element: '[required_id_or_htmlelement]',
          parameters: {
            badge: "bottomright", // '[inline|bottomright|bottomleft]', // optional, default undefined
            theme: useColorMode().colorMode === "dark" ? "dark" : "light", // optional, default undefined
          },
        }}
        reCaptchaKey={reCaptchaSiteKey ?? ""}
        scriptProps={{
          appendTo: "head",
          async: true,
          defer: true,
          nonce: nonce || undefined,
        }}
      >
        {children}
      </GoogleReCaptchaProvider>
    </>
  )
}
